import { render, staticRenderFns } from "./PaymentOnboardSection.vue?vue&type=template&id=12823615&scoped=true"
import script from "./PaymentOnboardSection.vue?vue&type=script&lang=js"
export * from "./PaymentOnboardSection.vue?vue&type=script&lang=js"
import style0 from "./PaymentOnboardSection.vue?vue&type=style&index=0&id=12823615&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12823615",
  null
  
)

export default component.exports